import { createContext, useContext, useEffect } from 'react';

import { MISSING_PROVIDER_ERROR } from './constants';
import type { NavigationCollapseContext } from './types';

const defaultContextValue: NavigationCollapseContext = {
    collapsed: false,
    setCollapsed: () => {
        throw new Error(MISSING_PROVIDER_ERROR);
    }
};

export const context = createContext<NavigationCollapseContext>(defaultContextValue);

export const useNavigationCollapse = (collapsed?: boolean): NavigationCollapseContext => {
    const { collapsed: currentCollapsed, setCollapsed } = useContext(context);

    useEffect(() => {
        if (collapsed !== undefined) {
            setCollapsed(collapsed);

            return () => {
                setCollapsed(false);
            };
        }
    }, [collapsed, setCollapsed]);

    return {
        collapsed: currentCollapsed,
        setCollapsed
    };
};
